module.exports = __webpack_public_path__ + "static/img/panoramaTerritorio.2f66d37.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/territorio/panoramaTerritorio.jpg
// module id = 9XDs
// module chunks = 1